<template>
    <div class="common-nav-bar">
        <div class="menu-wrapper">
            <a class="header-link" href="/" title="Home">
                <img class="nav-heder-icon" src="/assets/app/quiz/icon-header-logo.svg"/>
            </a>
            <span style="font-weight: bold; color: chocolate;" v-if="isAdminPremium">PREMIUM</span>
            <div class="menu-toggle" @click="isMenuOpened = !isMenuOpened" v-if="isMobileNav">
                <img class="icon-toggle" :src="menuIcon"/>
                <span class="toggle-title">{{ menuTitle }}</span>
            </div>
        </div>
        <div class="nav-buttons-wrapper" ref="menuContainer" v-if="isMenuVisible">
            <div class="account-menu-wrapper">
                <div class="premium-wrapper">
                  <div style="display: flex" v-if="!showPremium">
                    <rt-picture class="icon-premium" src="/assets/app/navigation/icon-diamond.svg" ></rt-picture>
                  </div>
                  <div style="display: flex" v-if="showPremium" @click="$emit('pemiumButtonClicked')">
                    <rt-picture class="icon-premium" src="/assets/app/navigation/icon-diamond.svg" ></rt-picture>
                    <span>Try premium</span>
                  </div>
                </div>
                <div class="account-wrapper">
                    <div class="account-button-wrapper"
                        @click="handleShowAccountDropdown"
                    >
                        <user-avatar
                            :isProfileAvatar="true"
                            :userName="username"
                            :userIcon="userIcon"
                            :avatarColor="avatarColor"
                        />
                        <img class="dropdown-icon" :src="dropdownIcon" v-if="!isMobileNav"/>
                    </div>
                    <div :class="{'dropdown-menu': true, 'teacher-menu': isTeacherNav, premium: showPremium}" v-if="isDropdownVisible">
                        <div v-for="(dropdown, idx) in dropdownButtons" :key="idx + dropdownButtons.length">
                            <a
                                :class="{'dropdown-button': true, premium: dropdown.type === 'premium',  active: dropdown.name === currentNavName}"
                                :href="dropdown.href"
                                @click="handleClickDropdown(dropdown.type, $event)"
                                v-if="!dropdown.separate_line"
                            >
                                <div class="dropdown-icon-wrapper">
                                    <img class="button-icon" :src="getNavIconPath(dropdown.icon, !dropdown.no_hover && dropdown.name === currentNavName)" />
                                </div>
                                <span class="button-title">{{ dropdown.name }}</span>
                            </a>
                            <div class="separate-line" v-else></div>
                        </div>
                        <div class="premium-menu-wrapper" v-if="showPremium">
                            <p class="premium-description">Subscribe to the <b>Premium plan</b> to open more functions.</p>
                            <primary-button class="btn-choose-plan" @click="$emit('pemiumButtonClicked')">
                                <img src="/assets/app/navigation/icon-diamond.svg"/>
                                <span>Choose your plan</span>
                            </primary-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navs-wrapper">
                <div class="nav-item-wrapper" v-for="(nav, idx) in leftNavButtons" :key="idx" :title="nav.name">
                    <a :class="{'navigation-button': true, active: nav.name === currentNavName}" :href="nav.href">
                        <div class="nav-icon-wrapper" :class="{ challenge: nav.icon === 'reading-challenge' }">
                            <img :src="getNavIconPath(nav.icon)" />
                        </div>
                        <span class="button-title">{{ nav.name }}</span>
                    </a>
                </div>
            </div>
            <div class="navs-wrapper right-navs" v-if="isMobileNav">
                <div class="nav-item-wrapper" v-for="(nav, idx) in dropdownButtons" :key="idx" :title="nav.name">
                    <a :class="{'navigation-button': true, active: nav.name === currentNavName}" :href="nav.href" @click="handleClickDropdown(nav.type, $event)">
                        <span class="button-title">{{ nav.name }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="activity-ribbon-wrapper" ref="activityRibbonRef" v-if="showActivityRibbon">
			<div class="activity-ribbon">
				<span>ReadTheory Knowledge Week Competition is starting now!</span>
				<a
					href="/app/teacher/activities?create_global_competiton=true"
					@click="reportActivityEvent"
				>Click here to join</a>
				<primary-button class="btn-normal" @click="handleClickCloseActivityRibbon">
					<img src="/assets/app/class/icon-closed.svg"/>
				</primary-button>
			</div>
		</div>
		<div class="sales-ribbon-wrapper" ref="salesRibbonRef" v-if="showSalesRibbon">
			<div class="sales-ribbon">
				<span>NOVEMBER SALE | Get 50% Off Premium Subscriptions Now!</span>
				<a @click="$emit('onShowSubscribe')">Subscribe</a>
				<primary-button class="btn-normal" @click="handleClickCloseRibbon">
					<img src="/assets/app/class/icon-closed.svg"/>
				</primary-button>
			</div>
		</div>
    </div>
</template>

<script>
import UserAvatar from '../UserAvatar.vue'
import PrimaryButton from '../PrimaryButton.vue';
import { constants } from "config";
import { isSubscriptionActive, isAdminImpersonate } from "../../../../common/UserService";
import RtPicture from "../Picture.vue";

export default {
  components: {
    RtPicture,
    UserAvatar,
    PrimaryButton
  },
  props: {
    isTeacherNav: Boolean,
    isMobileNav: Boolean,
    username: String,
    userIcon: String,
    avatarColor: String,
    showPremium: Boolean,
    showActivityRibbon: Boolean,
    showSalesRibbon: Boolean,
    currentNavName: String,
    leftNavButtons: {
      type: Array,
      default: []
    },
    dropdownButtons: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      isDropdownVisible: false,
      isMenuOpened: false
    }
  },
  computed: {
    menuIcon() {
	  return !this.isMenuOpened ? `${constants.ASSETS_BASE_DIR}/navigation/icon-menu.svg` : `${constants.ASSETS_BASE_DIR}/navigation/icon-close-red.svg`;
    },
    menuTitle() {
	  return !this.isMenuOpened ? 'Menu' : 'Close';
    },
    isMenuVisible() {
      return !this.isMobileNav || (this.isMobileNav && this.isMenuOpened);
    },
    dropdownIcon() {
	  return this.isDropdownVisible ? `${constants.ASSETS_BASE_DIR}/navigation/icon-drop-up.svg` : `${constants.ASSETS_BASE_DIR}/navigation/icon-drop-down.svg`;
    },
    isAdminPremium() {
      return isSubscriptionActive(false) && isAdminImpersonate();
    }
  },
  created() {
    window.addEventListener('click', this.handleClickWindow);
  },
  destroyed() {
    window.removeEventListener('click', this.handleClickWindow);
  },
  methods: {
    getNavIconPath(iconName, isCurrentNav = false) {
	  const prefix = isCurrentNav ? '-hover' : '';
	  return `${constants.ASSETS_BASE_DIR}/navigation/icon-${iconName}${prefix}.svg`;
    },
    isActivityBageVisibleFor(navName) {
	  const activityState = localStorage.getItem('competition_ribbon');
	  return navName === 'Activities' && activityState !== 'dismissed';
	},
    handleClickWindow(e) {
	  if (!this.isMobileNav && !e.target.classList.contains('account-button-wrapper')) {
	    this.isDropdownVisible = false;
	  }
    },
    handleShowAccountDropdown() {
	  if (!this.isMobileNav) {
	    this.isDropdownVisible = !this.isDropdownVisible;
	  }
	},
    handleClickDropdown(dropdownType, event) {
      this.$emit('dropdownClicked', dropdownType, event);
    },
    handleClickCloseActivityRibbon() {
		this.$refs.activityRibbonRef.classList.add('dismissed');
		localStorage.setItem('competition_ribbon', 'dismissed');
	},
    handleClickCloseRibbon() {
	  this.$refs.salesRibbonRef.classList.add('dismissed');
	  localStorage.setItem('sales_alert', 'dismissed');
	}
  }
}
</script>

<style lang="scss" scoped>
@import './navigation';

.common-nav-bar {
    .menu-wrapper {
	  display: flex;
	  align-items: center;
	  justify-content: space-between;

	  .menu-toggle {
		display: flex;
		align-items: center;
		background: #fff;
		padding: 13px;
		border-radius: 32px;
		cursor: pointer;

		.icon-toggle {
		  width: 16px;
		}
		.toggle-title {
		  margin-left: 10px;
		  line-height: 1;
		  font-weight: bold;
		  font-size: 16px;
		  color: #FF9874;
		}
	  }
	}

    .nav-heder-icon {
      width: 31px;
      margin-right: 51px;
    }

	  .nav-buttons-wrapper {
	    .account-menu-wrapper {
        display: flex;
		    position: absolute;
		    right: 0;
        .premium-wrapper {
          margin-right: 14px;
          display: flex;
          height: 32px;
          align-items: center;
          cursor: pointer;
          span {
            margin-left: 8px;
            font-weight: 700;
            font-size: 14px;
            color: $light-blue2;;
          }
        }
	    }

	  .navs-wrapper {
		&.right-navs {
		  padding-left: 32px;
		  padding-right: 116px;
		  .navigation-button {
		    padding: 0;
			.button-title {
			  font-style: normal;
			  font-size: 14px;
			}

			&:hover {
			  background: none;
			  text-decoration: underline;
			  text-decoration-color: #424851;
			}
			&.active {
			  background: #fff;
			  padding: 4px 8px;

			  .button-title {
				font-weight: bold;
			  }
			}
		  }
		}

		.nav-item-wrapper:last-child {
		  .navigation-button {
			margin: 0;
		  }
		}
	  }
	}

    .navigation-button {
      display: flex;
      align-items: center;
      margin-right: 32px;
      padding: 4px 8px;
	  border-radius: 12px;
	  text-decoration: none;

      &:hover, &.active {
        background: #fff;
      }

      .nav-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
		position: relative;
        width: 32px;
        height: 32px;
        background: #fff;
        border-radius: 8px;
		&.challenge {
		  background: none;
		}
      }

      .button-title {
        margin-left: 8px;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        color: #424851;
		white-space: nowrap;
      }
	}

    @keyframes slidedown {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(-50px);
      }
    }
    .activity-ribbon-wrapper, .sales-ribbon-wrapper {
        width: 100%;
        height: 50px;
        background: $light-yellow;
        z-index: 1;
        .activity-ribbon, .sales-ribbon {
          max-width: 1440px;
          margin: 0 auto;
          padding: 13px 16px;
          position: relative;
          a {
            margin-left: 20px;
            cursor: pointer;
          }
          .btn-normal {
            position: absolute;
            right: 20px;
            top: 50%;
            margin: 0;
            transform: translateY(-50%);
            img {
              width: 15px;
            }
          }
        }
        &.dismissed {
          height: 0;
          animation: slidedown 1s;
          transition: 1s;
          transform: translateY(-50px);
        }
    }

    .account-wrapper {
      position: relative;
      user-select: none;
      .account-button-wrapper {
        display: flex;
        align-items: center;
        cursor: pointer;
        .dropdown-icon {
          margin-left: 8px;
          pointer-events: none;
        }
      }

      .dropdown-menu {
        position: absolute;
        right: 0;
        top: 100%;
        width: 240px;
        background: #fff;
        margin-top: 10px;
        padding: 8px 0;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        &.teacher-menu {
            width: 260px;
        }
        &.premium {
            width: 290px;
            padding-bottom: 0;
        }
        .dropdown-button {
            display: flex;
            align-items: center;
            padding: 24px 32px;
            .dropdown-icon-wrapper {
              width: 24px;
              height: 24px;
              text-align: right;
              pointer-events: none;
              img {
                width: 24px;
              }
            }
            .button-title {
              margin-left: 12px;
              font-weight: bold;
              font-size: 14px;
              color: $title-dark-grey;
              pointer-events: none;
              &.nav-title {
                margin: 0;
              }
            }

            &:hover, &.active {
              background: $light-blue;
              .button-title {
                color: $light-blue2;
              }
            }
        }
        .premium-menu-wrapper {
          background: #F3F8FF;
          padding: 32px;
          border-radius: 0px 0px 16px 16px;
          .premium-description {
            font-size: 14px;
            color: $title-grey;
            b {
              color: $title-dark-grey;
            }
          }
          .btn-choose-plan {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 24px;
            margin-bottom: 0;
            width: 100%;
            span {
              margin-left: 8px;
              font-weight: 700;
              font-size: 14px;
              color: #fff;
            }
          }
        }
        .separate-line {
          height: 2px;
          margin: 0 32px;
          background: $light-blue6;
        }
      }
    }
}

@media (max-width: 1350px) {
	.common-nav-bar {
	  .nav-buttons-wrapper {
      .premium-wrapper {
        display: none !important;
      }
		  .navs-wrapper {
		  .navigation-button {
			margin-right: 15px;
		  }

		  &.right-navs {
			padding-left: 10px;
			padding-right: 80px;
		  }
		}
	  }
	}
}

@media (max-width: 1100px) {
  .common-nav-bar {
    .nav-buttons-wrapper {
        .navs-wrapper {
        .navigation-button {
            .nav-icon-wrapper {
            display: none;
            }
            .button-title {
            margin: 0;
            }
        }
        }
    }
  }
}

@media (max-width: 767px) {
	.common-nav-bar.rt-navigation-bar {
	  display: block;

	  .menu-wrapper {
		flex: 1;
		height: 72px;
	  }

	  .nav-buttons-wrapper {
		display: block;

		.account-menu-wrapper {
		  position: relative;

		  .account-wrapper {
		    .account-button-wrapper {
			  justify-content: space-between;
			  padding: 16px 0 12px;
			}

			.dropdown-menu {
			  position: relative;
			  width: 100%;
			  background: transparent;
			  box-shadow: none;
			  margin: 0;
			  .dropdown-button {
			  	padding: 20px 10px 20px 16px;
			  }
			}
		  }
	  	}

		.navs-wrapper {
		  display: block;
		  .nav-item-wrapper {
			padding: 16px 0;
			border-bottom: 1px solid #DCE5ED;
			.navigation-button {
			  margin: 0;
			  padding-left: 0;
			  .nav-icon-wrapper {
				display: flex;
			  }
			  .button-title {
				margin-left: 8px;
			  }
			}

			&:last-child {
			  border: 0;
			}
		  }

		  &.right-navs {
			background: #fff;
			margin-left: -20px;
    		margin-right: -20px;
			padding: 8px 0 3px;

			.nav-item-wrapper {
			  padding-top: 28px;
			  padding-left: 20px;
			  border: 0;
			  &:last-child {
				padding-bottom: 24px;
			  }

			  .navigation-button {
				&:hover, &.active {
				  padding: 0;
				}
			  }
			}
		  }
		}
	  }
	}
}

</style>